import { Image } from '@/components/ui/image';
import PageLoaderGif from '@/assets/placeholders/product-loader.gif';

interface PageLoaderProps {
  width?: number;
}

const PageLoader = ({ width = 200 }: PageLoaderProps) => {
  return (
    <Image src={PageLoaderGif} alt="logo da qualidoc animada" width={width} unoptimized={true} />
  );
};

export default PageLoader;
